import { useMemo } from "react";

import { useViewConverter } from "../../utils";
import {
    useEarnPortfolioPositionsDomain,
    useEarnVaultPositionDomain,
    UseEarnVaultPositionParams
} from "../domain/earn-positions";

export function useEarnVaultPosition(params: UseEarnVaultPositionParams) {
    const domain = useEarnVaultPositionDomain(params);
    const { convertEarnVaultPositionResponse } = useViewConverter();

    const data = useMemo(
        () => (domain.data ? convertEarnVaultPositionResponse(domain.data) : undefined),
        [domain.data, convertEarnVaultPositionResponse]
    );

    return {
        data,
        isLoading: domain.isLoading,
        isFetching: domain.isFetching
    };
}

export function useEarnPortfolioPositions(wallet: string | undefined) {
    const domain = useEarnPortfolioPositionsDomain(wallet);
    const { convertEarnVaultPositionResponse } = useViewConverter();

    const data = useMemo(
        () => domain.data?.map(convertEarnVaultPositionResponse),
        [domain.data, convertEarnVaultPositionResponse]
    );

    return {
        data,
        isLoading: domain.isLoading,
        isFetching: domain.isFetching
    };
}

export type { UseEarnVaultPositionParams };
